import React, { useState, useContext } from "react";
import {
    Grid, // our UI Component to display the results
    SearchBar, // the search bar the user will type into
    SearchContext, // the context that wraps and connects our components
    SearchContextManager, // the context manager, includes the Context.Provider
    // SuggestionBar, // an optional UI component that displays trending searches and channel / username results
} from "@giphy/react-components";
// import { GiphyFetch } from "@giphy/js-fetch-api";
import "./AddGiphy.css";
import ResizeObserver from "react-resize-observer";

// import { processPostInput } from "../../helpers/processPostInput";

const AddGiphy = ({
    setGiphyPostOption,
    giphyPostOption,
    apiKey,
    onGifSelect,
}) => (
    <SearchContextManager apiKey={apiKey}>
        <GiphyComponents
            setGiphyPostOption={setGiphyPostOption}
            giphyPostOption={giphyPostOption}
            onGifSelect={onGifSelect}
        />
    </SearchContextManager>
);

const GiphyComponents = ({
    setGiphyPostOption,
    giphyPostOption,
    onGifSelect,
}) => {
    const { fetchGifs, searchKey } = useContext(SearchContext);
    const [width, setWidth] = useState(window.innerWidth);

    return (
        <>
            <div
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault(); // ⛔ prevent outer form submission
                    }
                }}
            >
                <SearchBar className="pb-5 pt-5 border" />
            </div>

            <div className="max-h-[300px] overflow-y-auto pr-1 mt-4">
                <Grid
                    noLink
                    onGifClick={(gif, event) => {
                        // Set embed in parent
                        onGifSelect?.(gif);

                        // Close Giphy UI
                        setGiphyPostOption(false);
                        window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    key={searchKey}
                    width={width}
                    columns={3}
                    gutter={6}
                    fetchGifs={fetchGifs}
                />
            </div>

            <ResizeObserver
                onResize={({ width }) => {
                    setWidth(width);
                }}
            />
        </>
    );
};

export default AddGiphy;
